import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as MarkupBundleService from '../services/markupBundleService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { parseRatingListRequestParams } from '../utils/commonUtils';
import {
    setListMarkupBundle as setListMarkupBundlesAction,
    setMarkupBundleDetail as setMarkupBundleDetailAction,
} from './../actions/markupBundleAction';
import history from '../helpers/history';
import { get } from 'lodash';

function* getListMarkupBundle() {
    yield takeLatest(Types.MARKUP_BUNDLE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        // const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        // const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        // const params = {
        //     ...action.filters,
        //     pageSize, pageIndex,
        // };
        const params = parseRatingListRequestParams(action.filters || {})
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(MarkupBundleService.getMarkupBundle, params);
        yield put(setListMarkupBundlesAction(result));
    }, errorHandleMarkupBundle(Types.MARKUP_BUNDLE_LIST_FAIL)))
}

function* getMarkupBundleDetail() {
    yield takeLatest(Types.MARKUP_BUNDLE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(MarkupBundleService.getMarkupBundleDetail, action.id);
        yield put(setMarkupBundleDetailAction(result));
    }, errorHandleMarkupBundle(Types.MARKUP_BUNDLE_DETAIL_FAIL)))
}

function* updateMarkupBundleDetail() {
    yield takeLatest(Types.MARKUP_BUNDLE_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(MarkupBundleService.updateMarkupBundleDetail, action.markupBundle.markupBundle);
        successHandleMarkupBundle(action, action.markupBundle.markupBundle.name);
        yield put(setMarkupBundleDetailAction(action.markupBundle.markupBundle));
        history.push(PATHS.MARKUP_BUNDLE.LIST.path);
        history.go();
    }, errorHandleMarkupBundle(Types.MARKUP_BUNDLE_UPDATE_FAIL)))
}

function* createMarkupBundleDetail() {
    yield takeLatest(Types.MARKUP_BUNDLE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(MarkupBundleService.createMarkupBundleDetail, action.markupBundle);
        successHandleMarkupBundle(action, action.markupBundle.name);
        yield put(setMarkupBundleDetailAction(result));
        history.push(PATHS.MARKUP_BUNDLE.LIST.path);
        history.go();
    }, errorHandleMarkupBundle(Types.MARKUP_BUNDLE_DETAIL_FAIL)))
}

function* deleteMarkupBundleDetail() {
    yield takeLatest(Types.MARKUP_BUNDLE_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(MarkupBundleService.deleteMarkupBundleDetail, action.markupBundle);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = parseRatingListRequestParams(action.filter || {});
        const resultList = yield call(MarkupBundleService.getMarkupBundle, params);
        yield put(setListMarkupBundlesAction(resultList));
    }, errorHandleMarkupBundle(Types.MARKUP_BUNDLE_DETAIL_FAIL)));
}

function successHandleMarkupBundle(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.markupBundle.title')} "${value}"`
    })
}

function errorHandleMarkupBundle(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {        
        yield put({ type: errorActionType, error: get(e, 'errors[0]')})
    }, 'markupBundle', true);
}

export function* markupBundleSaga() {
    yield all([
        fork(getListMarkupBundle),
        fork(getMarkupBundleDetail),
        fork(updateMarkupBundleDetail),
        fork(createMarkupBundleDetail),
        fork(deleteMarkupBundleDetail)
    ])
}
